import React from 'react';
import { useHistory } from 'react-router-dom';
import I18n from 'i18n-js';

import { TNoCardsDialogContent } from '@lootboy/lib/slices/cardCollections/types';

import StyledButton, {
  EStyledButtonVariant,
} from '~/components/atoms/StyledButton';
import Image from '~/components/Image';

import { getPathFromInternalLink } from '~/utils';

import styles from './NoCardsDialogContent.module.scss';

interface INoCardsDialogContentProps {
  content: TNoCardsDialogContent;
  closeDialog: () => Promise<void>;
}

const NoCardsDialogContent: React.FC<INoCardsDialogContentProps> = ({
  content,
  closeDialog,
}) => {
  const history = useHistory();

  const buttonLinkPath =
    'buttonLink' in content && getPathFromInternalLink(content.buttonLink);

  return (
    <div className={styles.container}>
      <Image
        alt="No available cards"
        path={content.image}
      />
      <h3>{content.headline}</h3>
      <p>{content.text}</p>
      <div className={styles.actions}>
        <StyledButton
          variant={EStyledButtonVariant.GRAY}
          className={styles.confirm}
          onClick={closeDialog}
        >
          {I18n.t('common_okay')}
        </StyledButton>
        {buttonLinkPath && 'buttonText' in content && (
          <StyledButton
            variant={EStyledButtonVariant.BLUE}
            className={styles.link}
            onClick={async () => {
              await closeDialog();
              history.push(buttonLinkPath);
            }}
          >
            {content.buttonText}
          </StyledButton>
        )}
      </div>
    </div>
  );
};

export default React.memo(NoCardsDialogContent);
